
// Gets the general Backend url (flask app)
export const getBaseURL = () => {
  if (process.env.REACT_APP_API_BASE_URL) {
    return process.env.REACT_APP_API_BASE_URL;
  }
  return undefined;
};

/** Absolute API URL for fetch paths; uses REACT_APP_API_BASE_URL (same as axiosInstance). */
export const getApiUrl = (path) => {
  const base = getBaseURL();
  if (!base) {
    throw new Error(
      "REACT_APP_API_BASE_URL is not set. Add it to .env (e.g. http://localhost:8081/) and restart the dev server."
    );
  }
  const normalizedPath = path.startsWith("/") ? path : `/${path}`;
  return `${String(base).replace(/\/$/, "")}${normalizedPath}`;
};

// ML Base URL - use env variable or fallback based on environment
export const optimcrBase = process.env.REACT_APP_ML_BASE_URL || (process.env.REACT_APP_ENV === 'production' ? 'https://api.optimcr.xyz' : 'https://dev.optimcr.xyz');

export const brennan_fetch_url = `${optimcrBase}/v1/ml`; // Client Load URL - need to strip out logic for case info
export const workups_url = `${optimcrBase}/v1/ml/workups`; // New server endpoint for KNN
export const visualizations_url = `${optimcrBase}/v1/viz/get_plot`; // New server endpoint for visualizations
